import React from "react";
import { Typography, Box } from "@material-ui/core";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { useTranslation } from "react-i18next";
import type { Observable } from "rxjs";
import * as Yup from "yup";

import type { IResponse } from "App/Modules/Models";
import type { IPartnersRepository } from "App/Modules/Repositories";
import { FormsDialog, PartnerSelectField } from "App/ReactComponents/Shared";

export type CreateType = "Site" | "Team" | "Company";

type CreateAnythingDialogProps = {
    onClose: (typeToCreate: CreateType, data: IResponse<CreatedEntityWithId>) => void;
    onSubmit: (typeToCreate: CreateType, entity: CreateEntityByName) => Observable<IResponse<CreatedEntityWithId>>;
    open: boolean;
    typeToCreate: CreateType;
    mmPartnersRepository: IPartnersRepository;
};

export type CreateEntityByName = {
    name: string;
    partnerId: string;
};

export type CreatedEntityWithId = {
    id: string;
    name: string;
};

export const CreateAnythingDialog = (props: CreateAnythingDialogProps) => {
    const { t } = useTranslation();
    const { typeToCreate } = props;
    const validationSchema = Yup.object().shape({
        name: Yup.string().min(2).max(50).required(),
        partnerId: Yup.string().required(),
    });
    const handleSubmit = (data: CreateEntityByName) => {
        return props.onSubmit(props.typeToCreate, data);
    };
    return (
        <FormsDialog<CreateEntityByName, CreatedEntityWithId>
            initialValues={{ name: "", partnerId: "" }}
            open={props.open}
            onClose={(data) => props.onClose(typeToCreate, data)}
            onSubmitting={handleSubmit}
            validationSchema={validationSchema}
            title={t("Gui.Manage.AddAnything.AddTitleFormat", {
                typeToCreate: t(`Entities.${typeToCreate}.${typeToCreate}`).toLowerCase(),
            })}
        >
            <Field component={TextField} fullWidth name="name" label="Name" />
            <PartnerSelectField
                fullWidth
                name="partnerId"
                label="Partner"
                mmPartnersRepository={props.mmPartnersRepository}
            />
            <Box mt={1}>
                <Typography variant="body2">{t(`Entities.${typeToCreate}.EntityDescription`)}</Typography>
            </Box>
        </FormsDialog>
    );
};
